import React, {useState} from 'react';
import {
   Image,
   Text,
   TouchableOpacity,
   View,
   Dimensions,
   Platform,
} from 'react-native';
//import Slider from 'react-native-slider';
import Slider from '../../components/slider';
import {
   FONT_FAMILY_BOLD,
   WHITE_ICON_HOVER_TINT_COLOR,
   isAndroid,
   isiOS,
} from '../../utils/utils';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import BottomControll from './BottomControll';
import {useSelector} from 'react-redux';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {isTablet as isTabletForWeb} from 'react-device-detect';
const {width, height} = Dimensions.get('window');

const CustomController = props => {
   const isTablet = useSelector(selectScreenOrientation);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isNextEnable, setIsNextEnable] = useState(props.isSlideAvailable);
   const isWeb = Platform.OS === 'web';
   const isWindows = Platform.OS === 'windows';
   const isMacos = Platform.OS === 'macos';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const [isHover, setHover] = useState(false);
   const leftArrowLeftMargin = isWeb
      ? !isLandscapeMode
         ? -7
         : -10
      : !isLandscapeMode
      ? 7
      : 10;
   return (
      <View
         onPress={() => {}}
         style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            ...Platform.select({
               web: {
                  height: isLandscapeMode
                     ? isTabletForWeb
                        ? window.innerHeight * 0.8
                        : '85vh'
                     : '100%',
                  zIndex: 1000,
                  transform: 'translate3d(0,0,0)',
               },
            }),
         }}>
         <View
            style={{
               position: 'absolute',
               flex: 1,
               width: '100%',
               height: '100%',
            }}>
            {props.showControl && props.isVideo && (
               <View>
                  {/* <Svg
                     height="100%"
                     width="200%"
                     style={StyleSheet.absoluteFillObject}>
                     <Defs>
                        <LinearGradient
                           id="grad"
                           x1="0%"
                           y1="100%"
                           x2="0%"
                           y2="0%">
                           <Stop
                              offset="0%"
                              stopColor="rgba(81, 83, 82, 0.5)"
                              stopOpacity="0"
                           />
                           <Stop
                              offset="100%"
                              stopColor="#141414"
                              stopOpacity="1"
                           />
                        </LinearGradient>
                     </Defs>
                     <Rect width="100%" height="100%" fill="url(#grad)" />
                  </Svg> */}
                  <UISvg
                     height="100%"
                     width={Platform.OS === 'web' ? '100%' : '200%'}
                     x1="0%"
                     y1="100%"
                     x2="0%"
                     y2="0%"
                     offset={['0%', '100%']}
                     stopColor={['rgba(81, 83, 82, 0.5)', '#141414']}
                  />

                  <View
                     style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '35%',
                        ...Platform.select({
                           web: {
                              background:
                                 'linear-gradient(#202020cc 0%, #20202000 100%)',
                              paddingHorizontal: 16,
                              paddingVertical: 10,
                              height: '100%',
                           },
                        }),
                     }}>
                     {!isWeb && (
                        <UISvg
                           height="200%"
                           width={
                              Platform.OS === 'android' || Platform.OS === 'ios'
                                 ? '250%'
                                 : '100%'
                           }
                           x1="50%"
                           y1="0%"
                           x2="50%"
                           y2="100%"
                           offset={['0%', '100%']}
                           stopColor={['#202020cc', '#20202000']}
                           stopOpacity={['1', '0']}
                           rectWidth={'100%'}
                           rectHeight={isMacos ? '15%' : '100%'}
                        />
                     )}
                     <View
                        style={[
                           {
                              flex: 1,
                              flexDirection: 'row',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                           },
                           isiOS &&
                              !isLandscapeMode && {
                                 marginLeft: 40,
                              },
                        ]}>
                        <TouchableOpacity
                           onMouseEnter={() => setHover(true)}
                           onMouseLeave={() => setHover(false)}
                           style={{padding: 10, marginRight: 8}}
                           onPress={() => props.onListPress()}>
                           <Image
                              source={require('../../assets/back_arrow.png')}
                              style={[
                                 {
                                    width: !isLandscapeMode ? 20 : 18,
                                    height: !isLandscapeMode ? 20 : 18,
                                    marginLeft: leftArrowLeftMargin,
                                 },
                                 isHover && {
                                    tintColor: WHITE_ICON_HOVER_TINT_COLOR,
                                 },
                              ]}
                           />
                        </TouchableOpacity>
                        <Text
                           style={{
                              fontSize: isTablet ? 24 : 16,
                              fontWeight: '600',
                              fontFamily: FONT_FAMILY_BOLD,
                              color: 'white',
                           }}>
                           {props.title}
                        </Text>
                     </View>
                     {/** Norcat logo at top right corner */}
                     {/* {(!isWeb ||
                        isLandscapeMode ||
                        isLandscapeSmallWebView) && (
                        <Image
                           source={require('../../assets/norcat_logo_white.png')}
                           style={{
                              width: isTablet ? 200 : 175,
                              height: isTablet ? 22 : 18,
                              resizeMode: 'contain',
                           }}
                        />
                     )} */}
                  </View>
               </View>
            )}
            <TouchableOpacity
               onPress={() => props.handleControls()}
               style={{flex: 1}}>
               {props.showControl && props.isVideo && (
                  <View
                     style={{
                        flexDirection: 'row',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom:
                           isMacos || isWindows
                              ? '22%'
                              : isLandscapeMode && !isWeb
                              ? '12%'
                              : '5%',
                     }}>
                     {!((isWindows || isMacos || isWeb) && isLandscapeMode) && (
                        <TouchableOpacity onPress={() => props.previousSlide()}>
                           <Image
                              source={require('../../assets/Back_Forward.png')}
                              style={{
                                 opacity: props.currentSlide === 0 ? 0.5 : 1,
                                 height: isTablet ? 120 : 48,
                                 width: isTablet ? 120 : 48,
                              }}
                           />
                        </TouchableOpacity>
                     )}
                     <TouchableOpacity
                        style={{marginStart: 20}}
                        onPress={() => {
                           props.onPlayPauseClick();
                        }}>
                        <Image
                           source={
                              props.isPlaying
                                 ? require('../../assets/pause-icon.png')
                                 : require('../../assets/play-icon.png')
                           }
                           style={{
                              height: isTablet ? 120 : 48,
                              width: isTablet ? 120 : 48,
                              opacity: isTablet ? 0.7 : 1,
                           }}
                        />
                     </TouchableOpacity>
                     {!((isWindows || isMacos || isWeb) && isLandscapeMode) &&
                     isNextEnable ? (
                        <TouchableOpacity
                           style={{marginStart: 20}}
                           onPress={() => props.nextSlide()}>
                           <Image
                              source={require('../../assets/Next_Forward.png')}
                              style={{
                                 opacity:
                                    props.currentSlide === props.totalSlide - 1
                                       ? 0.5
                                       : 1,
                                 height: isTablet ? 120 : 48,
                                 width: isTablet ? 120 : 48,
                              }}
                           />
                        </TouchableOpacity>
                     ) : null}
                  </View>
               )}
            </TouchableOpacity>
            {props.showControl && (
               <View
                  style={{backgroundColor: '#202020', paddingHorizontal: 10}}>
                  {/* <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}> */}
                  {!((isWindows || isMacos || isWeb) && isLandscapeMode) && (
                     <>
                        {/* </View> */}

                        <BottomControll
                           duration={props.duration}
                           currentTime={props.currentTime}
                           isPlaying={props.isPlaying}
                           volume={props.volume}
                           totalSlide={props.totalSlide}
                           showControl={props.showControl}
                           currentSlide={props.currentSlide}
                           isVideo={props.isVideo}
                           slideTitle={props.slideTitle}
                           // onValueChange={value => {
                           //    props.onValueChange(value);
                           // }}
                           onFeedbackClick={() => {
                              props.onFeedbackClick();
                           }}
                           onVolumeChage={value => {
                              props.onVolumeChage(value);
                           }}
                           onHomePress={() => {
                              props.onHomePress();
                              //To do land back on Course details
                           }}
                           onListPress={() => {
                              props.onListPress();
                           }}
                           previousSlide={() => {
                              props.previousSlide();
                           }}
                           nextSlide={() => props.nextSlide()}
                           onPlayPauseClick={() => {
                              props.onPlayPauseClick();
                           }}
                           isNextEnable={isNextEnable}
                           toggleFullScreen={props.toggleFullScreen}
                           // props for seekbar slider:
                           value={props.currentTime}
                           minimumValue={0}
                           {...(!isWeb && {
                              onSeekBarValueChange: value =>
                                 props.onSeekBarValueChange(value),
                           })}
                           {...(isWeb && {
                              onSeekBarSlidingComplete: value =>
                                 props.onSeekBarSlidingComplete(value),
                           })}
                           disabled={props.disabled}
                           maximumValue={props.duration}
                           thumbTouchSize={{width: 15, height: 15}}
                           thumbStyle={{height: 15, width: 15}}
                           minimumTrackTintColor="#6E8EFF"
                           maximumTrackTintColor="#CECECE"
                           trackStyle={{
                              height: 8,
                              borderRadius: 5,
                              backgroundColor: '#585858',
                           }}
                           style={{
                              height: 12,
                              padding: 0,
                              margin: 0,
                              marginTop: 8,
                              ...Platform.select({
                                 web: {
                                    cursor: 'pointer',
                                 },
                                 android: {
                                    marginBottom: isTablet ? 15 : 10,
                                    marginTop: 0,
                                 },
                                 ios: {
                                    marginBottom: isTablet ? 15 : 10,
                                    marginTop: 0,
                                 },
                              }),
                           }}
                           thumbTintColor={'#6E8EFF'}
                           isReviewTest={props.isReviewTest}
                        />
                     </>
                  )}
               </View>
            )}
         </View>
      </View>
   );
};

export default CustomController;
